// extracted by mini-css-extract-plugin
export default {"inDevelopment":"ToggleWrapper_inDevelopment__kVWQi"};